import React from 'react';

import {colors} from 'js-libs/sweetcommons/styles';
import moment from 'moment-tz';
import styled from 'styled-components';

import {FullHTMLLink} from 'app/components/general/FullHTMLLink';
import {DocumentSequencedStepsStatusIcon} from 'app/general/doc-status';
import {CheckboxButton} from 'app/general/widgets/CheckboxButton';
import {useTaskUpdate} from 'app/tasks/task-update-hook';
import {simpleGetProgressLabel} from 'app/tasks/utils';

import type {SlimTaskInstanceSerializedType} from 'sweet-types';

interface Props {
  task: SlimTaskInstanceSerializedType;
  isCurrent?: boolean;
  userTimezone: string;
}
export function RelatedTaskInstanceItem({
  userTimezone,
  task,
  isCurrent,
}: Props): JSX.Element {
  const {toggleTaskCompleted} = useTaskUpdate();

  return (
    <div className="small p-2 d-flex" id={`task${task.id}`}>
      <StyledContainerFullHTMLLink
        html_url={task.tasks_url}
        className={isCurrent === true ? 'current' : ''}
      >
        <div>
          {moment(task.due).tz(userTimezone).format('lll')}
          {task.comment_count != null && task.comment_count > 0 ? (
            <span className="ml-1 badge badge-light">
              <i className="far fa-comments" /> {task.comment_count}
            </span>
          ) : null}
        </div>
        {getTaskStatus(task)}
      </StyledContainerFullHTMLLink>
      {task.is_completeable ? (
        <StyledCheckbox
          disabled={!task.is_completeable}
          fixedWidth={true}
          onClick={() => toggleTaskCompleted(task)}
          isChecked={task.completed != null}
          className={`btn btn-link py-0 px-1 ${
            isCurrent === true ? 'current' : ''
          }`}
        />
      ) : (
        <DocumentSequencedStepsStatusIcon
          className="py-0 px-1 d-flex align-items-center"
          isSequenced={true}
          contentType={task.template.assigned_object.content_type}
        />
      )}
    </div>
  );
}

const getTaskStatus = (
  task: SlimTaskInstanceSerializedType
): React.ReactElement<'div'> => {
  const {text, style} = simpleGetProgressLabel(task);
  return <div className={`small font-italic text-${style}`}>{text}</div>;
};

const StyledCheckbox = styled(CheckboxButton)`
  &.current {
    color: #fff;
  }
`;
const StyledContainerFullHTMLLink = styled(FullHTMLLink).attrs<{
  className: string;
}>({
  className: 'clearfix',
})`
  flex-grow: 1;
  color: ${colors.textDefault};

  &.current {
    color: #fff;

    .small {
      color: #fff !important;
    }
  }
`;
